/<!--
2021-07-06 C007 增加withdraw实名认证相关逻辑
-->
<template>
  <div class="withdrawSetupPage">
    <div class="setupContainer" v-if="setupType === 'account'">
      <div v-for="(bankCard,rowNum) in accountInfo" :key="rowNum"
           v-if="setupType === 'account'&&($store.state.bankList.length===3||($store.state.bankList.length<3&&rowNum<=$store.state.bankList.length))"
           :class="$store.state.bankList[rowNum]&&$store.state.bankList[rowNum].IsLastUsed?'bankcard':'bankcard1'">
        <div class="bankcardBK" v-if="$store.state.bankList[rowNum]&&$store.state.bankList[rowNum].Id" @click="chooseCard($store.state.bankList[rowNum].Id)"/>
        <div class="header">{{ $t('lang.menu.Account') }} {{ (rowNum + 1) * 1 }}</div>
        <div class="row" v-show="key!=='Id'" v-for="(key, index) in Object.keys(bankCard)"
             :key="index">
          <div class="caption">
            {{ accountDict[key] }}
          </div>
          <div class="inputRow">
            <div class="input">
              <label>
                <input type="text" @change="(event)=>toUpperCase(event, key)"
                       :readonly="$store.state.bankList &&$store.state.bankList[rowNum] && $store.state.bankList[rowNum].BankCardVerifyStatus > 0"
                       v-model="accountInfo[rowNum][key]" :placeholder="accountDict[key]">
              </label>
            </div>
          </div>
        </div>
        <div class="submit" @click="setAccount(rowNum)"
             v-if="$store.state.verifyInfo == null || !$store.state.bankList[rowNum]||$store.state.bankList[rowNum].BankCardVerifyStatus<=0">
          {{ $t('lang.common.submit') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import frontSide from '@/assets/images/common/frontSide.svg'
import backSide from '@/assets/images/common/backSide.svg'
import withCard from '@/assets/images/common/withCard.svg'
import request from '@/service'
import {mapMutations} from 'vuex'
import {InternationBankList, InternationIFSCReg, InternationAccountNumberReg, InternationIDCardReg} from '@/constant'

export default {
  name: 'WithdrawSetup',
  props: ['setupType', 'handelBack', 'parentChoose', 'fetchVerifyInfo'],
  data () {
    return {
      frontSide,
      backSide,
      withCard,
      activeCardId: '',
      title: '',
      idSetup: 'info',
      documentList: [
        {
          key: 'frontSide',
          label: this.$t('lang.account.withdrawSetup.textFrontSide'),
          src: frontSide,
          fileServer: this.$store.state.verifyInfo ? this.$store.state.verifyInfo.FrontSideImage : null,
          isUploading: false
        },
        {
          key: 'backSide',
          label: this.$t('lang.account.withdrawSetup.textBackSide'),
          src: backSide,
          fileServer: this.$store.state.verifyInfo ? this.$store.state.verifyInfo.BackSideImage : null,
          isUploading: false
        },
        {
          key: 'withCard',
          label: this.$t('lang.account.withdrawSetup.textPhoto'),
          src: withCard,
          fileServer: this.$store.state.verifyInfo ? this.$store.state.verifyInfo.PhotoWithCardImage : null,
          isUploading: false
        }
      ],
      personalInfo: {
        fullName: this.$store.state.verifyInfo ? this.$store.state.verifyInfo.FullName : null,
        cardNum: this.$store.state.verifyInfo ? this.$store.state.verifyInfo.AadhaarCardNumber : null,
        mobile: ''
      },
      personalDict: {
        fullName: this.$t('lang.account.withdrawSetup.textFullName'),
        cardNum: this.$t('lang.account.withdrawSetup.textCardNumber'),
        mobile: this.$t('lang.account.withdrawSetup.textMobileNumber')
      },
      accountInfo: [{
        Id: null,
        AccountName: null,
        AccountNumber: null,
        BankCode: null
      }, {
        Id: null,
        AccountName: null,
        AccountNumber: null,
        BankCode: null
      }, {
        Id: null,
        AccountName: null,
        AccountNumber: null,
        BankCode: null
      }],
      accountDict: {
        AccountName: this.$t('lang.account.accountName'),
        AccountNumber: this.$t('lang.account.accountNo'),
        BankCode: this.$t('lang.account.IFSC')
      },
      downloadLnk: 'https://api.pgebet.com/mobileapp/pge-' + (localStorage.getItem('cid') || 'app') + '-1.4.0.apk',
      bankListSlots: [
        {
          flex: 1,
          values: [],
          textAlign: 'center'
        }
      ],
      AccountNameReg: RegExp(/^[a-zA-Z\s]+$/),
      IFSCReg: RegExp(/^[A-Za-z]{4}[0]\w{6}$/),
      AccountNumberReg: RegExp(/^\d{8,18}$/),
      AadhaarReg: RegExp(/^\d{12}$/),
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      InternationBankList,
      InternationIFSCReg,
      InternationAccountNumberReg,
      InternationIDCardReg
    }
  },
  watch: {
    '$store.state.locale': function () {
      if (this.setupType === 'account') {
        this.title = this.$t('lang.account.withdrawSetup.textYourBank')
        this.accountDict = {
          AccountName: this.$t('lang.account.accountName'),
          AccountNumber: this.$t('lang.account.accountNo'),
          BankCode: this.$t('lang.account.IFSC')
        }
      }
    }
  },
  mounted () {
    switch (this.setupType) {
      case 'id':
        this.title = 'Your ID'
        request('post', '/innovation/account/getuserinfo', {
          userId: this.userInfo.UserId
        }).then(res => {
          console.log(res)
          this.personalInfo.mobile = '+' + res.CountryCode + ' ' + res.Mobile
        })
        break
      case 'account':
        this.title = this.$t('lang.account.withdrawSetup.textYourBank')
        // 2022-02-17 CHP 根据国家版本设置相关信息
        this.bankListSlots[0].values = this.InternationBankList.getBankList(this.$store.state.internation)
        this.IFSCReg = this.InternationIFSCReg.getReg(this.$store.state.internation)
        this.AccountNumberReg = this.InternationAccountNumberReg.getReg(this.$store.state.internation)
        // bankList 赋值
        if (this.$store.state.bankList && this.$store.state.bankList.length > 0 && this.$store.state.bankList.length < 4) {
          this.$store.state.bankList.forEach((item, index) => {
            // 第一次加载记录上次使用的卡
            if (item.IsLastUsed) {
              this.activeCardId = item.Id
            }
            if (item.Id) {
              this.accountInfo[index].Id = item.Id
            }
            this.accountInfo[index].AccountName = item.AccountName
            this.accountInfo[index].AccountNumber = item.AccountNumber
            this.accountInfo[index].BankCode = item.BankCode
          })
          if (this.activeCardId === -1 && this.$store.state.bankList && this.$store.state.bankList.length > 0) {
            this.activeCardId = this.$store.state.bankList[0].Id
          }
          this.chooseCard(this.activeCardId)
        }
        break
    }
  },
  components: {},
  methods: {
    ...mapMutations({
      setUserVerifyInfo: 'setUserVerifyInfo',
      setCurrentRoute: 'setCurrentRoute',
      setUserBankList: 'setUserBankList'
    }),
    chooseCard (id) {
      let bankList = this.$store.state.bankList
      bankList.forEach((e) => {
        if (e.Id === id) {
          e.IsLastUsed = true
        } else {
          e.IsLastUsed = false
        }
      })
      this.setUserBankList(bankList)
      this.parentChoose(id)
    },
    toUpperCase (event, key) {
      if (key === 'IFSC') {
        event.target.value = event.target.value.toUpperCase()
      }
    },
    upload (key) {
      if (!this.$store.state.verifyInfo ||
        (this.$store.state.verifyInfo && this.$store.state.verifyInfo.IDVerfiyStatus <= 0)) {
        this.$refs[key][0].click()
      }
    },
    uploadFile (key) {
      if (this.$refs[key][0].files.length > 0) {
        let index = 0
        switch (key) {
          case 'frontSide':
            index = 0
            break
          case 'backSide':
            index = 1
            break
          case 'withCard':
            index = 2
            break
        }
        this.documentList[index].isUploading = true
        this.documentList[index].fileServer = null

        let formData = new FormData()
        formData.append('userId', this.userInfo.UserId)
        formData.append('documentType', key)
        formData.append('file', this.$refs[key][0].files[0])
        request('post',
          '/innovation/account/uploadpersonaldocument',
          formData, true).then(res => {
          this.$message.info(res.Message)

          if (res.Code > 0) {
            this.documentList[index].fileServer = res.S3FileURL
            this.setUserVerifyInfo(res.UserVerifyInfo)
          }

          this.documentList[index].isUploading = false
        }).catch(err => {
          console.log(err)
          this.documentList[index].isUploading = false
        })
      }
    },
    setAccount (rowNum) {
      switch (this.setupType) {
        case 'id':
          if (!this.personalInfo.fullName || !this.personalInfo.fullName.trim()) {
            this.Toast(this.$t('lang.account.withdrawSetup.promptFillName'))

            if (this.idSetup === 'img') {
              this.idSetup = 'info'
            }
            return
          }

          let pattern = /\d{2}-\d{2}-\d{4}/
          if (!this.personalInfo.Birthday || !this.personalInfo.Birthday.trim() || !pattern.test(this.personalInfo.Birthday)) {
            this.Toast(this.$t('lang.account.withdrawSetup.promptFillBirthday'))

            if (this.idSetup === 'img') {
              this.idSetup = 'info'
            }
            return
          }

          if (!this.personalInfo.cardNum) {
            this.Toast(this.$t('lang.account.withdrawSetup.promptFillCard'))

            if (this.idSetup === 'img') {
              this.idSetup = 'info'
            }
            return
          }

          if (!this.AadhaarReg.test(this.personalInfo.cardNum)) {
            this.Toast(this.$t('lang.account.withdrawSetup.promptCardInvalid'))

            if (this.idSetup === 'img') {
              this.idSetup = 'info'
            }
            return
          }

          if (!this.documentList[0].fileServer) {
            this.Toast(this.$t('lang.account.withdrawSetup.promptUploadFrontCard'))

            if (this.idSetup === 'info') {
              this.idSetup = 'img'
            }
            return
          }

          if (!this.documentList[1].fileServer) {
            this.Toast(this.$t('lang.account.withdrawSetup.promptUploadBackCard'))

            if (this.idSetup === 'info') {
              this.idSetup = 'img'
            }
            return
          }

          if (!this.documentList[2].fileServer) {
            this.Toast(this.$t('lang.account.withdrawSetup.promptUploadPhoto'))

            if (this.idSetup === 'info') {
              this.idSetup = 'img'
            }
            return
          }

          const url = '/innovation/account/setuseridinfo'
          const data = {
            userId: this.userInfo.UserId,
            FullName: this.personalInfo.fullName.trim(),
            Birthday: this.personalInfo.Birthday,
            AadhaarCardNumber: this.personalInfo.cardNum
          }
          request('post', url, data).then(res => {
            this.Toast(res.Message)
            switch (res.Code) {
              case 0:
                if (this.idSetup === 'info') {
                  this.idSetup = 'img'
                }
                this.setUserVerifyInfo(res.UserVerifyInfo)
                break
              case 10:
                this.setUserVerifyInfo(res.UserVerifyInfo)
                break
              case -1:
                break
            }
          }).catch(err => {
            console.log(err)
            this.Toast(this.$t('lang.account.withdrawSetup.errorUpload'))
          })
          break
        case 'account':
          if (this.accountInfo[rowNum].AccountName && this.accountInfo[rowNum].AccountName.trim() && this.accountInfo[rowNum].AccountNumber && this.accountInfo[rowNum].BankCode) {
            if (!this.AccountNameReg.test(this.accountInfo[rowNum].AccountName.trim())) {
              this.Toast(this.$t('lang.account.withdrawSetup.promptInvalidAccountName'))
              return
            }
            if (!this.AccountNumberReg.test(this.accountInfo[rowNum].AccountNumber)) {
              this.Toast(this.$t('lang.account.withdrawSetup.promptInvalidAccount'))
              return
            }
            if (!this.IFSCReg.test(this.accountInfo[rowNum].BankCode)) {
              this.Toast(this.$t('lang.account.withdrawSetup.promptInvalidCard'))
              return
            }
            const url = '/innovation/account/set/userbankaccount'
            const data = {
              UserId: this.userInfo.UserId,
              AccountName: this.accountInfo[rowNum].AccountName.trim(),
              AccountNumber: this.accountInfo[rowNum].AccountNumber,
              BankCode: this.accountInfo[rowNum].BankCode,
              Id: this.accountInfo[rowNum].Id
            }
            request('post', url, data).then(res => {
              this.Toast(res.Message)
              if (res.Code > 0) {
                this.fetchVerifyInfo()
              }
            }).catch(err => {
              console.log(err)
              this.Toast(this.$t('lang.account.withdrawSetup.errorUpload'))
            })
          } else if (!this.accountInfo[rowNum].accountName || !this.accountInfo[rowNum].accountName.trim()) {
            this.Toast(this.$t('lang.account.withdrawSetup.promptFillAccountName'))
          } else if (!this.accountInfo[rowNum].accountNo) {
            this.Toast(this.$t('lang.account.withdrawSetup.promptFillAccountNumber'))
          } else if (!this.accountInfo[rowNum].IFSC) {
            this.Toast(this.$t('lang.account.withdrawSetup.promptFillIFSC'))
          }
          break
      }
    },
    copy () {
      this.$refs.link.select()
      document.execCommand('copy')
      this.this.Toast(this.$t('lang.account.copySuccess'))
    },
    Toast (msg) {
      this.$message.error(msg)
    }
  }
}
</script>

<style lang="less" scoped>
.withdrawSetupPage {
  /*position: absolute;
  top: 0;
  left: -16px;
  width: 100vw;
  min-height: 100%;
  max-height: calc(100vh - 126px);*/
  /*overflow: auto;*/
  /*ackground-color: #151515;*/

  .setupContainer {
    padding: 20px 16px 30px;

    .tabContainer {
      display: flex;
      border: 1px solid rgba(246, 217, 170, 0.5);
      border-radius: 6px;
      margin-bottom: 30px;

      .tabItem {
        flex: 1;
        font-size: 14px;
        line-height: 32px;
        color: rgba(246, 217, 170, 0.5);
        border-radius: 6px;
        text-align: center;
      }

      .act {
        color: #543200;
        background: #F6D9AA;
        border: 1px solid rgba(246, 217, 170, 0.5);
      }
    }

    .setupContent {
      padding-bottom: 30px;

      .upload {
        width: 255px;
        height: 145px;
        margin: 0 auto 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        border: 1px solid rgba(246, 217, 170, 0.5);
        border-radius: 6px;

        .documentIcon {
          height: 24px;
        }

        .documentImage {
          width: 90%;
          height: 100px;
        }

        .label {
          margin-top: 10px;
          font-size: 14px;
          line-height: 16px;
          color: rgba(246, 217, 170, 0.5);
        }
      }

      .new-version-prompt, .download-lnk {
        font-size: 12px;
        text-align: justify;
        margin-bottom: 10px;
        color: #AA0000;
      }

      .linkRow {
        justify-content: space-between;
        margin-bottom: 10px;

        label {
          width: 100%;
          line-height: 30px;

          input {
            font-size: 14px;
            color: #C4C4C4;
            width: 100%;
          }
        }

        .copy {
          font-size: 14px;
          color: rgba(246, 217, 170, 0.5);
          padding: 5px 10px;
          border: 1px solid #818181;
          line-height: 20px;
          width: 100px;
          text-align: center;
          margin: 0 auto;
        }
      }
    }

    .bankcard {
      position: relative;
      left: 50%;
      transform: translate(-50%);
      padding: 2vw;
      border: 3px solid #F6D9AA;
      border-radius: 8px;
      margin-bottom: 2vw;
      cursor: pointer;
    }

    .bankcard1 {
      position: relative;
      left: 50%;
      transform: translate(-50%);
      padding: 2vw;
      border: 3px solid #7D705D;
      border-radius: 8px;
      margin-bottom: 2vw;
      cursor: pointer;
    }

    .bankcardBK {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
    }

    .header {
      width: 100%;
      font-size: 30px;
      font-weight: 700;
      color: #F6D9AA;
      margin-bottom: 30px;
      text-align: center;
    }
    .row {
      margin-bottom: 20px;

      .caption {
        font-size: 18px;
        line-height: 21px;
        color: #F6D9AA;
        margin-bottom: 10px;
      }

      .inputRow {
        display: flex;
        margin-bottom: 16px;

        div {
          flex: 1;
          text-align: right;
          line-height: 40px;
          border: 1px solid rgba(246, 217, 170, 0.5);
          border-radius: 6px;
          padding-right: 15px;

          input {
            width: 100%;
            font-size: 16px;
            color: #F6D9AA;
            text-align: right;
          }
        }
      }
    }

    .submit {
      margin-top: 30px;
      font-size: 22px;
      line-height: 50px;
      color: #000D2E;
      text-align: center;
      background-color: #F6D9AA;
      border-radius: 6px;
    }
  }

  .ani_dot {
    font-family: simsun;
  }

  :root .ani_dot { /* 这里使用Hack是因为IE6~IE8浏览器下， vertical-align解析不规范，值为bottom或其他会改变按钮的实际高度*/
    display: inline-block;
    width: 1.5em;
    vertical-align: bottom;
    overflow: hidden;
  }

  @-webkit-keyframes dot {
    0% {
      width: 0;
      margin-right: 1.5em;
    }
    33% {
      width: .5em;
      margin-right: 1em;
    }
    66% {
      width: 1em;
      margin-right: .5em;
    }
    100% {
      width: 1.5em;
      margin-right: 0;
    }
  }

  .ani_dot {
    -webkit-animation: dot 3s infinite step-start;
  }

  @keyframes dot {
    0% {
      width: 0;
      margin-right: 1.5em;
    }
    33% {
      width: .5em;
      margin-right: 1em;
    }
    66% {
      width: 1em;
      margin-right: .5em;
    }
    100% {
      width: 1.5em;
      margin-right: 0;
    }
  }

  .ani_dot {
    animation: dot 3s infinite step-start;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/WithdrawSetup/index.vue